const state = {
  students: [],
  isLoaded: false
}

export default state
